import i18n from '@lib/i18n';
import { Locale, LocaleField } from '../common/dataTypes';

/**
 * Function to get the (localized) full label of languages using their respective tag/code.
 * @param {array} langArr - e.g. ["en-US", "es-US"]
 */
const languagePairs: Locale = {
  'en-US': i18n.t('English - US'),
  'es-US': i18n.t('Spanish - US'),
  'en-CA': i18n.t('English - CA'),
  'fr-CA': i18n.t('French - CA'),
  'en-GB': i18n.t('English - GB'),
};

export function getLanguageLabels(langArr: LocaleField[]): string[] {
  return langArr.map(lang => languagePairs[lang]);
}
